<template>
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <el-select v-model="search.rulesType" placeholder="请选择规则类型">
          <el-option
            v-for="item in rulesType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addScope"
                @click="addOrEdit(null)"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table v-loading="loading" element-loading-text="加载中..."
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="规则类型"
            prop="rulesType"
          >
        <template slot-scope="scope">
         <span>{{ rulesType.find(rule=>rule.value===scope.row.rulesType).name }}</span>
        </template>
        </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欠费次数"
            prop="numberArrears"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欠费总金额"
            prop="amountArrears"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欠费时长（天数）"
            prop="durationArrears"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="是否启用"
            prop="activitFlag"
          >
        <template slot-scope="scope">
          <el-switch
          :value="scope.row.activitFlag=='y'?true:false"
          active-color="#13ce66"
          inactive-color="#6666"
          @change="(status)=>onActiveClick(scope.row,status)"
        >
        </el-switch>
        </template>
        </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
             
              <button class="edit" type="button" @click="addOrEdit(scope.row)">
                修改
              </button>
              <button class="delete" type="button" @click="del(scope.row.id)">
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page v-on:pagination="receivePaginationData"></page>
      <component
        :is="currentComponent"
        :oneDetail="oneDetail"
        @func="emptyComponent"
      ></component>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations } from "vuex";
  import {RULES_TYPE} from "./contants.js"
  import {
    getRuleConfigurationList,
    updateOneRuleConfiguration,
  } from "@/api/url";
  
  import Page from "../../commons/page.vue";
  import AddOrEdit from "./components/ruleAddOrEdit.vue";
 

 
  export default {
    data() {
      return {
      loading: false,
        rulesType:RULES_TYPE,
        styleObj: {
          "text-align": "center",
        },
        tableHeaderStyle: {
          "text-align": "center",
          background: "#F9F9FB",
        },
        oneDetail: null,
        currentComponent: null,
        search: {
          pageNumber: 1,
          pageSize: 10,
          rulesType: null,
        },
        tableListData: [],
      };
    },
    computed: mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    components: {
      Page,
      AddOrEdit,
    },
  
    mounted: function () {
      this.tableList(this.search.pageNumber);
    },
    methods: {
      ...mapMutations(["getPage"]),
      receivePaginationData(v1, v2) {
        this.search.pageNumber = v1;
        this.search.pageSize = v2;
        this.tableList(this.search.pageNumber);
      },
      tableList: function (curPage) {
        this.loading = true;
        this.$get(getRuleConfigurationList(), {
          limit: this.search.pageSize,
          page: curPage,
          rulesType: this.search.rulesType ? this.search.rulesType : null,
        }).then((res) => {
          const {
            status,
            data: { rows, offset, total },
          } = res;
          if (status !== 200) return;
          //翻页
          var pageObj = {
            curIndex: offset,
            rowsCount: total,
          };
          this.getPage(pageObj);
          this.tableListData =rows ;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
        }).finally(() => {
        this.loading = false;
      });
},
      searchList: function () {
        if (this.loading) return;
        this.search.pageNumber = "1";
        this.tableList(this.search.pageNumber);
      },
      addOrEdit(oneDetail) {
        oneDetail ? (this.oneDetail = {...oneDetail,activitFlag:oneDetail.activitFlag==='y'?true:false}) : (this.oneDetail = null);
        this.currentComponent = "add-or-edit";
      },
      emptyComponent(m) {
        this.currentComponent = null;
        switch (m) {
          case "add": {
            this.search.pageNumber = 1;
           
            this.tableList(this.search.pageNumber);
            break;
          }
          case "edit": {
            this.tableList(this.curIndex);
            break;
          }
        }
      },
      onActiveClick(row,isActive){
        const {id}=row
        console.log("is active=>",isActive)
        this.$putRequest(`${updateOneRuleConfiguration()}/${id}`, {
              ...row,
              activitFlag:isActive?'y':'n'
            }).then((res) => {
              const { status, message } = res;
              if (status === 200) {
                isActive? this.$message({
                  type: "success",
                  message: "规则已启用",
                }): this.$message({
                  type: "success",
                  message: "规则已禁用",
                })
                this.tableList(this.curIndex);
              } else {
                this.$message({
                  type: "warning",
                  message,
                });
              }
            });
      },
      del(id) {
        var _this = this;
        var index = _this.$layer.confirm(
          "您确定删除?",
          {
            btn: ["确定", "取消"],
            shade: true,
          },
          function () {
            _this.$layer.close(index);
            _this
              .$deleteRequest(`${updateOneRuleConfiguration()}/${id}`)
              .then((data) => {
                if (data.status != 200)
                  return _this.$layer.msg("删除失败", { time: 1 });
                _this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success",
                });
                _this.tableList(_this.curIndex);
              });
          }
        );
      },
    },
  };
  </script>
  <style scoped>
  .list {
    padding: 0 !important;
  }
  .table thead {
    background: #f9f9fb;
  }
  .searchbox .el-input {
    width: 180px !important;
  }
  </style>